module.exports = __webpack_public_path__ + "static/principles-939261c3813570fb2d103ad7f00cdb33.jpg";